import { useCrfFormSubmitAndReturn } from "@ngt/opms";
import { IConsentForm } from "../../api/dtos";

const useEConsentFormSubmitAndReturn =  <TData extends IConsentForm = IConsentForm>() => {
    return useCrfFormSubmitAndReturn<TData>();
};

export default useEConsentFormSubmitAndReturn;